export default "__VITE_ASSET__CDre8sJS__"